Ext.define('SA.VectorMapExportLegendOverlay', {
    alias: 'widget.vector-map-export-legend-overlay',
    extend: 'Ext.Component',

    cls: 'sa-vector-map-export-overlay',
    constrain: true,
    draggable: true,
    floating: true,
    height: 100,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,
    width: 100,

    resizable: {
        preserveRatio: true,
        transparent: true
    },

    initEvents() {
        this.callParent();

        this.mon(this.getRecord(), 'set:theme', this.refresh, this);
    },

    afterRender() {
        this.callParent();

        this.getEl().addClsOnClick('sa-vector-map-export-overlay-drag');
        this.refresh();
    },

    getRecord() {
        return this.details.getLegend();
    },

    onMouseDown: Ext.emptyFn,

    refresh() {
        var {details} = this,
            modelState = this.model.getState(),
            pageWidth = this.page.getWidth(),
            params = SA.VectorMapExportParams.forLegend({details, modelState, pageWidth}),
            record = this.getRecord();

        this.svg?.remove();
        this.svg = this.getEl().dom.appendChild(SA.VectorMapExportLegend.getSvg(params));

        record.updateAspectRatio(SA.Svg.getRect(this.svg).width, SA.Svg.getRect(this.svg).height);
    }
});